__turbopack_context__.v({
  "lockIcon": "pageTopSection-module-scss-module__-l3ifq__lockIcon",
  "section": "pageTopSection-module-scss-module__-l3ifq__section",
  "title": "pageTopSection-module-scss-module__-l3ifq__title",
});
